/*
 * File: quick.ts
 * Created: 2026-02-03
 * Author: Val Liu
 */

import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { ObjectHelper } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";

const _ = UIQuick.getInstance;

@UIQuick.set()
export class Ledger extends IQuickUnit {
    title = "w_MenuLedger";
    path = "/ledger";
    icon = "fa-solid fa-file-invoice-dollar";

    /// hierarchy
    parents = () => [_`Organization`];
    children = null;

    /// file
    file = false;

    /// params
    paramsWhere = PARAMS_WHERE;
    paramsRead = function () {
        return ObjectHelper.deepMerge(
            {
                orderBy: [
                    {
                        createdAt: "desc",
                    },
                ],
            },
            PARAMS_INCLUDE,
        );
    };

    allowCreate = false;
    allowUpdate = false;
    allowDelete = false;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/ledger.read.interface").default;
    infRead = require("raw-loader!./interfaces/ledger.read.interface").default;
    infCreate = require("raw-loader!./interfaces/ledger.read.interface").default;
    infUpdate = require("raw-loader!./interfaces/ledger.read.interface").default;
    infDelete = require("raw-loader!./interfaces/ledger.read.interface").default;
}
